import React from "react";

import LegalLayout from "../LegalLayout";

function PolitiqueCookie() {
  return (
    <LegalLayout title="Politique de Cookies">
        <h2 className="fs-4 mt-4">1. Introduction</h2>

        <p>
            Ce site utilise uniquement les cookies strictement nécessaires à son bon fonctionnement.
            Aucun cookie publicitaire, statistique ou de suivi n’est déposé sur votre appareil.
        </p>

        <h2 className="fs-4 mt-4">2. Qu’est-ce qu’un cookie ?</h2>

        <p>
            Un cookie est un petit fichier texte enregistré sur votre navigateur lors de la consultation d’un site internet.
            Il permet au site de mémoriser certaines informations pour améliorer la navigation.
        </p>

        <h2 className="fs-4 mt-4">3. Cookies utilisés sur ce site</h2>

        <p>
            Cookies techniques essentiels : nécessaires pour garantir le bon fonctionnement du site (ex. navigation entre les pages, affichage correct du contenu).
        </p>

        Aucun autre cookie (analyse, publicité, traçage) n’est utilisé.

        <h2 className="fs-4 mt-4">4. Gestion des cookies</h2>

        <p>
            Comme aucun cookie facultatif n’est utilisé, il n’est pas nécessaire de demander votre consentement.
            Vous pouvez toutefois configurer votre navigateur pour bloquer tous les cookies si vous le souhaitez.
        </p>

        <h2 className="fs-4 mt-4">5. Contact</h2>

        <p>
            Pour toute question concernant cette politique, vous pouvez nous contacter à :
            📧 contact@auto-formations.fr
        </p>
        <p>
            📍 154 rue Lavoisier, 57601 Forbach Cedex
        </p>
    </LegalLayout>
    
  );
}

export default PolitiqueCookie;